/* eslint-env browser */

(function (window) {
    'use strict';

    var THEME_VERSION = '1.0.69';

    function getApiBase() {
        if (window.SiwaApp && window.SiwaApp.apiBase) {
            return window.SiwaApp.apiBase;
        }
        return window.location.origin + '/siwa-api';
    }

    function shortenPlanName(name, slug) {
        var slugValue = (slug || '').toLowerCase();
        var nameValue = (name || '').toLowerCase();

        if (slugValue === 'siwa-publisher' || nameValue.indexOf('publisher') !== -1) {
            return 'Publisher';
        }
        if (slugValue === 'siwa-personal' || nameValue.indexOf('personal') !== -1) {
            return 'Personal';
        }
        return name || '';
    }

    function labelFromTier(tier) {
        if (!tier) {
            return '';
        }
        return shortenPlanName(tier.name, tier.slug);
    }

    function planLabelFromGhostMember(member) {
        if (!member) {
            return 'Visitatore';
        }

        var tiers = member.tiers || [];
        var i;
        for (i = 0; i < tiers.length; i += 1) {
            var tierLabel = labelFromTier(tiers[i]);
            if (tierLabel) {
                return tierLabel;
            }
        }

        var subs = member.subscriptions || [];
        for (i = 0; i < subs.length; i += 1) {
            var sub = subs[i];
            if (!sub) {
                continue;
            }
            if (sub.status && sub.status === 'canceled') {
                continue;
            }

            var subLabel = labelFromTier(sub.tier);
            if (!subLabel && sub.price && sub.price.tier) {
                subLabel = labelFromTier(sub.price.tier);
            }
            if (!subLabel && sub.price && sub.price.product && sub.price.product.name) {
                subLabel = shortenPlanName(sub.price.product.name, sub.price.product.slug);
            }
            if (subLabel) {
                return subLabel;
            }
        }

        if (member.comped || member.status === 'comped') {
            return 'Personal';
        }
        if (member.status === 'gift') {
            return 'Gift';
        }
        if (member.paid || member.status === 'paid') {
            return 'Membro';
        }
        return 'Gratuito';
    }

    function planLabelFromSiwaMember(data) {
        if (!data || !data.tier_slug) {
            return '';
        }
        return shortenPlanName(null, data.tier_slug);
    }

    function currentSsrLabel() {
        var el = document.querySelector('[data-siwa-plan]');
        return el ? (el.textContent || '').trim() : '';
    }

    function shouldReplaceLabel(current, next) {
        if (!next || next === 'Visitatore') {
            return false;
        }
        if (!current || current === '…' || current === 'Visitatore') {
            return true;
        }
        if (current === 'Gratuito' && next !== 'Gratuito') {
            return true;
        }
        if (current === 'Membro' && (next === 'Personal' || next === 'Publisher')) {
            return true;
        }
        return current !== next;
    }

    function applyPlanLabel(label) {
        if (!label) {
            return;
        }
        document.querySelectorAll('[data-siwa-plan]').forEach(function (el) {
            el.textContent = label;
        });
    }

    function applyThemeVersion() {
        document.querySelectorAll('[data-siwa-theme-version]').forEach(function (el) {
            el.textContent = 'v' + THEME_VERSION;
        });
        document.querySelectorAll('[data-siwa-theme-version-full]').forEach(function (el) {
            el.setAttribute('title', 'Siwa Luxe v' + THEME_VERSION);
        });
    }

    function parseSessionToken(res) {
        if (!res.ok) {
            return null;
        }
        return res.text().then(function (text) {
            var trimmed = (text || '').trim();
            if (!trimmed) {
                return null;
            }
            if (trimmed.charAt(0) === '{') {
                try {
                    var data = JSON.parse(trimmed);
                    return data.identity || data.token || null;
                } catch (e) {
                    return null;
                }
            }
            return trimmed;
        });
    }

    function getSessionToken() {
        return fetch('/members/api/session/', { credentials: 'same-origin' })
            .then(parseSessionToken)
            .catch(function () {
                return null;
            });
    }

    function fetchGhostMember(token) {
        return fetch('/members/api/member/', {
            credentials: 'same-origin',
            headers: { Authorization: 'Ghost ' + token }
        })
            .then(function (res) {
                if (res.status === 204 || res.status === 401 || res.status === 403) {
                    return null;
                }
                if (!res.ok) {
                    return null;
                }
                return res.json();
            })
            .catch(function () {
                return null;
            });
    }

    function fetchSiwaMember(apiBase, token) {
        return fetch(apiBase + '/members/me', {
            credentials: 'omit',
            headers: { Authorization: 'Ghost ' + token }
        })
            .then(function (res) {
                if (!res.ok) {
                    return null;
                }
                return res.json();
            })
            .catch(function () {
                return null;
            });
    }

    function     resolvePlanLabel(token) {
        if (!token) {
            return Promise.resolve(null);
        }

        var apiBase = getApiBase();
        return fetchSiwaMember(apiBase, token)
            .then(function (siwaMember) {
                var siwaLabel = planLabelFromSiwaMember(siwaMember);
                if (siwaLabel) {
                    return siwaLabel;
                }
                return fetchGhostMember(token).then(planLabelFromGhostMember);
            });
    }

    function refreshPlanLabel() {
        var current = currentSsrLabel();
        return getSessionToken()
            .then(resolvePlanLabel)
            .then(function (label) {
                if (shouldReplaceLabel(current, label)) {
                    applyPlanLabel(label);
                }
            });
    }

    function init() {
        applyThemeVersion();
        refreshPlanLabel();
    }

    function bindPortalRefresh() {
        var events = ['portal:opened', 'portal:closed', 'portal:signup', 'portal:signin'];
        events.forEach(function (eventName) {
            document.addEventListener(eventName, refreshPlanLabel);
        });
        window.addEventListener('focus', refreshPlanLabel);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            init();
            bindPortalRefresh();
            setTimeout(refreshPlanLabel, 1200);
        });
    } else {
        init();
        bindPortalRefresh();
        setTimeout(refreshPlanLabel, 1200);
    }

    window.SiwaHeaderBadge = {
        init: init,
        refreshPlanLabel: refreshPlanLabel,
        planLabelFromGhostMember: planLabelFromGhostMember,
        themeVersion: THEME_VERSION
    };
})(window);
